import { createContext, useContext } from 'react';

/**
 * Provides a boolean indicating whether the enclosing tab panel is currently
 * the active (visible) tab. Defaults to `true` so components used outside of
 * the tabs pattern behave normally.
 *
 * Consumers (e.g. `Video`) should gate autoplay / side-effect logic on this
 * value so that media inside inactive tabs does not start playing while hidden.
 */
export const TabActiveContext = createContext<boolean>(true);

export const useTabActiveContext = (): boolean => useContext(TabActiveContext);
